import { supportedCurrencyInfo } from './constants';

/**
 * Format currency based on currency and locale to display on UI
 * @param amount
 * @param currencyCode
 * @returns string | null
 */
export var formatCurrency = function formatCurrency(amount, currencyCode) {
  if (amount == 0) {
    return '0';
  }
  var currencyFormates = supportedCurrencyInfo.filter(function (_ref) {
    var currency = _ref.currencyCode;
    return currency == currencyCode;
  });
  if (currencyFormates.length) {
    var _currencyFormates$ = currencyFormates[0],
      currencyFormat = _currencyFormates$.currencyFormat,
      currencySymbol = _currencyFormates$.currencySymbol,
      doNotShowDecimalPlaces = _currencyFormates$.doNotShowDecimalPlaces,
      locale = _currencyFormates$.locale;
    var numDecimalPlaces = doNotShowDecimalPlaces ? 0 : 2;
    if (currencyCode === 'ZAR' && amount !== 0) {
      var formattedZARAmt = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: numDecimalPlaces,
        maximumFractionDigits: numDecimalPlaces
      }).format(amount).replace('.', ',').replace(/R\s*/, 'R ');
      return formattedZARAmt;
    }
    var formattedAmt = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: numDecimalPlaces,
      maximumFractionDigits: numDecimalPlaces
    }).format(amount).replace(/(^)[a-zA-Z]+/, '').replace(currencySymbol, '').trim();
    return currencyFormat.replace(/{amount}/g, formattedAmt) || '';
  }
  return null;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/currencyFormatter/index.js
// module id = 640
// module chunks = 11